import { useState, useEffect } from "preact/hooks";
import { LANG_MAP } from "@/lib/enums";
import { clearLocalStorage } from "@/lib/storage";
import { toTitleCase } from "@/lib/strings";

const StagingConfig = ({ onCancel }) => {
  const [uiLang, setUiLang] = useState("");
  const [learnLang, setLearnLang] = useState("");
  const [skipPayment, setSkipPayment] = useState(false);

  // Initialize with current URL parameters
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    setUiLang(urlParams.get("ml") || "");
    setLearnLang(urlParams.get("pl") || "");
    setSkipPayment(urlParams.get("skip_payment") === "true");
  }, []);

  const handleSet = () => {
    // Clear session storage
    clearLocalStorage();

    // Get current URL parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Update with new language parameters
    if (uiLang) {
      urlParams.set("ml", uiLang);
    } else {
      urlParams.delete("ml");
    }

    if (learnLang) {
      urlParams.set("pl", learnLang);
    } else {
      urlParams.delete("pl");
    }

    // Update skip_payment parameter
    if (skipPayment) {
      urlParams.set("skip_payment", "true");
    } else {
      urlParams.delete("skip_payment");
    }

    // Reload the page with updated parameters via the logout endpoint
    const baseUrl = `${window.location.protocol}//${window.location.host}`;
    const newUrl = `${baseUrl}/logout?${urlParams.toString()}`;
    window.location.href = newUrl;
  };

  return (
    <div className="flex flex-col space-y-4 min-w-[300px]">
      <div className="flex flex-col space-y-2">
        <label htmlFor="ui-lang" className="text-gray-700 font-medium">
          UI Lang:
        </label>
        <select
          id="ui-lang"
          value={uiLang}
          onChange={(e) => setUiLang(e.target.value)}
          className="form-select w-full px-3 py-2 bg-white text-gray-900 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">Select UI Language</option>
          {Object.entries(LANG_MAP).map(([code, name]) => (
            <option key={code} value={code}>
              {toTitleCase(name)}
            </option>
          ))}
        </select>
      </div>

      <div className="flex flex-col space-y-2">
        <label htmlFor="learn-lang" className="text-gray-700 font-medium">
          Learn Lang:
        </label>
        <select
          id="learn-lang"
          value={learnLang}
          onChange={(e) => setLearnLang(e.target.value)}
          className="form-select w-full px-3 py-2 bg-white text-gray-900 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">Select Learning Language</option>
          {Object.entries(LANG_MAP).map(([code, name]) => (
            <option key={code} value={code}>
              {toTitleCase(name)}
            </option>
          ))}
        </select>
      </div>

      <div className="flex items-center">
        <input
          type="checkbox"
          id="skip-payment"
          checked={skipPayment}
          onChange={(e) => setSkipPayment(e.target.checked)}
          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
        />
        <label htmlFor="skip-payment" className="ml-2 block text-sm text-gray-700">
          Skip Payment
        </label>
      </div>

      <div className="flex justify-end space-x-3 pt-4">
        <button
          onClick={onCancel}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Cancel
        </button>
        <button
          onClick={handleSet}
          className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Set
        </button>
      </div>
    </div>
  );
};

export default StagingConfig;
